export enum ShiftListContainerTabs {
    Overview = 0,
    Reports = 1,
    Map = 2,
}

export const ListTitleBase = "Time Clock";
